import { TableCell, styled } from "@mui/material"

const Separator = styled("div")(({ theme: { palette, spacing } }) => ({
  position: "absolute",
  top: spacing(2),
  bottom: spacing(2),
  width: "1px",
  backgroundColor: palette.grey.extraLight,
}))

export const DividerCell = () => (
  <TableCell align="center" sx={{ position: "relative" }}>
    <Separator />
  </TableCell>
)
